// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { JobTypes } from './jobTypes';
import type { RunJobRequestParams } from './runJobRequestParams';

/**
 * Request to run a job
 */
export interface RunJobRequest {
  type: JobTypes;
  params: RunJobRequestParams;
  allowOverlappingJobs?: boolean;
}
